<div class="section-container" id="certificates">
  <div class="section-left">
    <h2>{{strings.certificates}}</h2>
  </div>

  <div class="section-right">
    <div class="certificates-section-wrapper">
      <div class="section-title">
        <h2 [innerHTML]="strings.certificatesSectionTitle"></h2>
      </div>
      <div class="certificates-section-content">
        <div class="certificates-titles">
          <h3 class="certificate-issuer">{{strings.certificateIssuer}}</h3>
          <h3 class="certificate-title">{{strings.certificateTitle}}</h3>
          <h3 class="certificate-view"></h3>
        </div>
        <div class="certificates-wrapper" *ngFor="let certificate of certificates">
          <div class="certificate-wrapper">
            <h3 class="certificate-issuer">{{certificate.issuer}}</h3>
            <h3 class="certificate-title">{{certificate.title}}</h3>
            <button type="button" class="certificate-view" (click)="viewCertificate(certificate)">{{strings.certificateView}}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

